import React from "react";
import { Page } from "@shopify/polaris";
import { useLocation, useParams } from "react-router-dom";

const StorePageFrame = ({
  title,
  children,
  maxWidth = "980px",
  gap = "20px",
  backAction,
  primaryAction,
}) => {
  const location = useLocation();
  const { id } = useParams();

  const currentStoreRoot = id ? `/store/${id}` : "";
  const isStoreRoot = id ? location.pathname === currentStoreRoot : false;
  const defaultBackAction = id
    ? isStoreRoot
      ? { content: "Stores", url: "/stores" }
      : { content: "Dashboard", url: currentStoreRoot }
    : undefined;

  return (
    <Page
      fullWidth
      title={title}
      backAction={backAction || defaultBackAction}
      primaryAction={primaryAction}
    >
      <div
        style={{
          width: "100%",
          maxWidth,
          margin: "0 auto",
          paddingTop: "24px",
          paddingBottom: "32px",
          display: "flex",
          flexDirection: "column",
          gap,
        }}
      >
        {children}
      </div>
    </Page>
  );
};

export default StorePageFrame;
